
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ColorCard, ColorLayout, ColorPalette } from '@ecl/website-components'
import tokens from '@ecl/eu-theme-default/exports/tokens.json'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The colour palette is designed to support a flexible, modular visual style that feels connected across EC and EU websites and platforms. The intent of the palette is to `}<strong parentName="p">{`convey a united and open European spirit`}</strong>{`, and leave users feeling welcome and in good hands.`}</p>
    <h2>{`Primary colours`}</h2>
    <hr></hr>
    <p>{`The `}<strong parentName="p">{`primary colour palette`}</strong>{` is comprised of blues, yellows and greys. These colours are present accross all pages and, together with the neutral white, they make up for about 80% of the colours in the page layout. Use these colours to `}<strong parentName="p">{`create consistency`}</strong>{` and a strong `}<strong parentName="p">{`visual hierarchy`}</strong>{` throughout the page.`}</p>
    <ColorLayout mdxType="ColorLayout">
  <ColorCard tokens={tokens} name="COLOR_PRIMARY" mdxType="ColorCard" />
  <ColorCard tokens={tokens} name="COLOR_SECONDARY" mdxType="ColorCard" />
  <ColorCard tokens={tokens} name="COLOR_TEXT" mdxType="ColorCard" />
    </ColorLayout>
    <h3>{`Variations`}</h3>
    <ColorLayout mdxType="ColorLayout">
  <ColorPalette tokens={tokens} category="color.variations.1" mdxType="ColorPalette" />
  <ColorPalette tokens={tokens} category="color.variations.2" mdxType="ColorPalette" />
  <ColorPalette tokens={tokens} category="color.variations.3" mdxType="ColorPalette" />
    </ColorLayout>
    <h2>{`Notification colours`}</h2>
    <hr></hr>
    <p>{`The secondary colour palette is mainly used for notification colours. The secondary colours should make up 20% or less of the colour in the layout and should be used sparingly to highlight important information and calls to action.`}</p>
    <ColorLayout cols="12 md-3" mdxType="ColorLayout">
  <ColorCard tokens={tokens} name="COLOR_INFO" mdxType="ColorCard" />
  <ColorCard tokens={tokens} name="COLOR_WARNING" mdxType="ColorCard" />
  <ColorCard tokens={tokens} name="COLOR_SUCCESS" mdxType="ColorCard" />
  <ColorCard tokens={tokens} name="COLOR_ERROR" mdxType="ColorCard" />
    </ColorLayout>
    <h2>{`Background colour`}</h2>
    <hr></hr>
    <p>{`White is the background colour of the EC-website.`}</p>
    <ColorLayout mdxType="ColorLayout">
  <ColorCard tokens={tokens} name="COLOR_WHITE_100" mdxType="ColorCard" />
    </ColorLayout>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;